// extracted by mini-css-extract-plugin
export var content = "_2h-3";
export var contentWrapper = "_2h-2";
export var fullWidthButton = "_2h-4";
export var heroImage = "_2h-6";
export var logo = "_2h-1";
export var logoContainer = "_2h-0";
export var panel = "_2h-5";